import { Mark } from 'tiptap'
import { toggleMark } from 'prosemirror-commands'

export default class HighlightMarkPink extends Mark {
    get name () {
        return 'highlight_mark_pink'
    }
    get schema () {
        return {
            attrs: {
                color: {
                    default: 'rgba(205, 50, 138, 1)',
                }
            },
            parseDOM: [
                {
                    style: 'color',
                    getAttrs (value) {
                        return { color: value }
                    }
                }
            ],
            toDOM (mark) {
                let { color } = mark.attrs
                return ['span', { style: `color: ${color}` }, 0]
            }
        };
    }
    commands ({ type }) {
        return attrs => toggleMark(type, attrs)
    }
}
